<template>
  <div class="list">
    <div class="list-left" @click="goShopDetail($route.query.shopId)">
      <div class="img-con">
        <img class="img" :src="shopDetail.shopAvatar + '?imageView2/0/w/80/h/80'" alt="">
        <div class="is-vip" v-if="shopDetail.isVipShop"></div>
      </div>
    </div>
    <div class="text-con" @click="goShopDetail($route.query.shopId)">
      <div class="list-title"><span class="name">{{ shopDetail.shopName }}</span></div>
      <div class="list-text">{{ shopDetail.signature || '&nbsp;'}}</div>
      <div class="sub-text">
        <span class="num">关注 {{ shopDetail.focusUserCount || 0 }}</span>
        <span class="num">商品 {{ shopDetail.goodsCount || 0 }}</span>
        <span class="num">人气 {{ shopDetail.orderCount || 0 }}</span>
      </div>
    </div>
    <div class="btn-con">
      <!--自己为店主时不能关注自己-->
      <div class="btn" v-if="shopDetail.userId !== userOpenId" :class="shopDetail.isUserFocus?'yes':'no'"
           @click="changeFocusShop($route.query.shopId)">{{ shopDetail.isUserFocus?'已关注':'+关注' }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { introduce, focusShop } from '@/api/mall/mallShop'
export default {
  data () {
    return {
      userOpenId: this.session('userOpenId'),
    }
  },
  computed: {
    ...mapGetters([
      'shopDetail'
    ])
  },
  created(){

  },
  methods: {
    // 跳转至店铺详情页
    goShopDetail(shopId){
      this.$router.push({name: 'mallShopDetail', query: {shopId: shopId}})
    },
    //  店铺 关注、取关
    changeFocusShop(shopId){
      focusShop({shopId}).then(res=>{
        this.getShopHome()
      })
    },
    //获取店铺信息
    getShopHome() {
      introduce({shopId: this.$route.query.shopId}).then(res=>{
        this.$store.dispatch('mall/changeShopDetail', res.data)
      })
    },
  }
}
</script>

<style lang="less" scoped>
  @url: '../../../../../assets/mall/';
  .list{
    display: flex;width: 375px;height: 76px;
    box-shadow: 0 1px 0 0 #edecec;
    .list-left{
      width: 79px;height: 100%;
      display: inline-flex;justify-content: center;align-items: center;
      .img-con{
        position: relative;z-index: 0;width: 55px;height: 55px;
        .img{
          display: block;width: 100%;height: 100%;border-radius: 50%;
        }
        .is-vip{
          position: absolute;z-index: 0;top: -7px;left: -2px;
          width: 20px;height: 17px;
          background: url("@{url}shop-vip.png") no-repeat 50% 50%;
          background-size: 100%;
        }
      }
    }
    .text-con{
      flex: 1;color: #2b2b2b;
      overflow: hidden;padding-top: 10px;
      .list-title{
        font-size: 14px;color: #000;
        .name{padding-right: 12px;}
      }
      .list-text{
        font-size: 10px;padding: 2px 0;overflow: hidden;
        text-overflow: ellipsis;white-space: nowrap;color: #999;
      }
      .sub-text{
        font-size: 10px;color: #999;
        .num{
          padding-right: 26px;
          &:last-child{
            padding-right: 0;
          }
        }
      }
    }
    .btn-con{
      width: 70px;font-size: 13px;
      display: inline-flex;justify-content: center;align-items: center;
      .btn{
        display: inline-flex;justify-content: center;align-items: center;
        width: 56px;height: 25px;
        color: #fff;border-radius: 13px;
        &.yes{
          background-color: #969799;
        }
        &.no{
          background-color: #1585f3;
        }
      }
    }
  }
</style>